import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const SEOStructuredData: FC = () => {
  const { t, i18n } = useTranslation();
  
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "LegalService",
    "name": i18n.language === 'zh' ? "WonderLand Australia 移民" : "WonderLand Australia",
    "description": t('seo.description'),
    "url": "https://your-domain.com",
    "telephone": "+61-XXX-XXX-XXX",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": t('footer.contact.address'),
      "addressLocality": "Sydney",
      "addressRegion": "NSW",
      "postalCode": "2000",
      "addressCountry": "AU"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "-33.8688",
      "longitude": "151.2093"
    },
    "openingHours": "Mo,Tu,We,Th,Fr 09:00-17:00",
    "priceRange": "$$",
    "sameAs": [
      "https://www.facebook.com/WonderLandmigration",
      "https://www.linkedin.com/company/WonderLand-migration"
    ],
    "alternateName": i18n.language === 'zh' ? "布莱特斯通移民" : "WonderLand Australia Services"
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  );
};